<template>
  <div class="parallax-comp-container">
    <div class="parallax-comp transparent position-relative"
         v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px', background: backgroundColor }"
    >
      <div v-if="insertMode === 1"
           class="imageBck" 
           v-bind:style="{ backgroundImage: transparent }">
      </div>
      <div v-if="insertMode === 2"
           class="imageBck" 
           v-bind:style="{ background: 'black' }">
      </div>
    </div>
    <div v-if="insertMode === 1 && background1"
         class="parallax-comp background-1 position-absolute"
         v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px' }"
    >
      <div class="imageBck" 
           v-bind:style="{ backgroundImage: background1, backgroundPositionX: background1Offset + 'px' }">
      </div>
    </div>
    <div v-if="insertMode === 1 && background2" 
         class="parallax-comp background-2 position-absolute"
         v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px' }"
    >
      <div class="imageBck" 
           v-bind:style="{ backgroundImage: background2, backgroundPositionX: background2Offset + 'px' }">
      </div>
    </div>
    <div v-if="insertMode === 1 && foreground1" 
         class="parallax-comp foreground-1 position-absolute"
         v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px' }"
    >
      <div class="imageBck" 
           v-bind:style="{ backgroundImage: foreground1 }">
      </div>
    </div>
    <div v-if="insertMode === 1 && foreground2" 
         class="parallax-comp foreground-2 position-absolute"
         v-bind:style="{ width: imageWidth + 'px', height: imageHeight + 'px' }"
    >
      <div class="imageBck" 
           v-bind:style="{ backgroundImage: foreground2, backgroundPositionX: foreground2Offset + 'px' }">
      </div>
    </div>

    <div class="parallax-textbox"
         :class="textboxClass"
         v-bind:style="{ background: textboxColor, 
                         transform: textboxZoom,
                         top: textboxPosition ? textboxPosition.top + 'px' : 0,
                         bottom: textboxPosition ? textboxPosition.bottom + 'px' : 0,
                         left: textboxPosition ? textboxPosition.left + 'px' : 0
                      }"
         v-show="description"
    >
      <div class="parallax-text"
           :class="textClass"
           v-bind:style="{ color: textColor }"
           v-html="textboxText"
      >
      </div>
    </div>
  </div>
</template>

<script>
  import { MENUS } from '../../config'

  // const DESKTOP_MIN_WIDTH = 769
  // const MAX_PREVIEW_SIZE_MOBILE = 671
  const DEFAULT_PREVIEW_SIZE = 600

  export default {
    props: {
      background1: {
        type: String,
        default: null
      },
      background2: {
        type: String,
        default: null
      },
      foreground1: {
        type: String,
        default: null
      },
      foreground2: {
        type: String,
        default: null
      },
      backgroundColor: {
        type: String,
        default: null
      },
      textboxColor: {
        type: String,
        default: null
      },
      textColor: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      },
      plusDetail: {
        type: String,
        default: null
      },
      showDetail: {
        type: Boolean,
        default: false
      },
      slide: {
        type: Number,
        default: 0
      },
      category: {
        type: Number,
        default: 1
      },
      editWidth: {
        type: Number,
        default: 600
      },
      insertMode: {
        type: Number,
        default: 1
      }
    },

    data () {
      return {
        transparent: 'url(' + require('assets/images/hd_transparent.png') + ')',
        imageWidth: 600
      }
    },

    mounted () {
      this.imageWidth = this.editWidth

      this.$nextTick(function () {
        window.addEventListener('resize', this.handleResize)
      })
    },

    computed: {
      background1Offset () {
        return (-(this.imageWidth * 180) / 600) * this.slide
      },

      background2Offset () {
        return (-(this.imageWidth * 360) / 600) * this.slide
      },

      foreground2Offset () {
        return (-(this.imageWidth * 150) / 600)
      },

      imageHeight () {
        return (this.imageWidth * 9) / 16
      },

      textboxText () {
        if (this.showDetail) {
          return this.description + this.plusDetail
        } else {
          return this.description
        }
      },

      textboxClass () {
        if (MENUS.eraumavez === this.category) {
          return 'parallax-textbox-eraumavez'
        }
        return 'parallax-textbox-default'
      },

      textClass () {
        if (MENUS.ambepoca === this.category) {
          return 'parallax-text-ambepoca'
        }
        return 'parallax-text-default'
      },

      textboxZoom () {
        return 'scale(' + this.imageWidth / DEFAULT_PREVIEW_SIZE + ')'
      },

      textboxPosition () {
        let position = {
          top: null,
          bottom: null,
          left: 11.25 * (this.imageWidth / DEFAULT_PREVIEW_SIZE)
        }

        if (MENUS.eraumavez === this.category) {
          position.top = 260 * (this.imageWidth / DEFAULT_PREVIEW_SIZE)
        } else {
          if (this.insertMode === 2) {
            position.bottom = 6.25
          } else {
            position.bottom = 0
          }
          position.bottom = position.bottom + 11.25 * (this.imageWidth / DEFAULT_PREVIEW_SIZE)
        }

        return position
      },

      isImage () {
        return !this.isVideo(this.background1)
      }
    },

    methods: {
      handleResize () {
        let element = document.getElementById('modal-preview-content')
        let elementEdit = document.getElementById('modal-edit-content')

        if (element && element.getBoundingClientRect().width !== 0) {
          this.imageWidth = element.getBoundingClientRect().width
        } else if (elementEdit && elementEdit.getBoundingClientRect().width !== 0) {
          this.imageWidth = elementEdit.getBoundingClientRect().width
        }
      },

      isVideo (path) {
        let videoExtensions = ['mp4', 'mov', 'mkv', 'avi']

        let splitPath = path.split('.')
        let extension = splitPath.pop()

        if (videoExtensions.includes(extension)) {
          return true
        }
        return false
      }
    }
  }
</script>

<style lang="scss">
  .parallax-comp-container {
    position: relative;
    top: 0;
    left: 0;
    width: 100% ;
  }

  .parallax-comp {
    // width: 600px;
    // height: 337.5px;
  }

  .imageBck {
    height: 100%;
    background-size: cover;
  }

  .position-relative {
    position: relative;
    top: 0;
    left: 0;
  }

  .position-absolute {
    position: absolute;
    top: 0;
    left: 0;
  }

  .parallax-comp-single-1,
  .parallax-comp-single-2 {
    top: 0;
    left: 0;
  }

  .parallax-textbox {
    width: 577.5px;
    position: absolute;
  }

  .parallax-textbox-default {
    opacity: 0.8;
    transform-origin: 0% 100%;
  }

  .parallax-textbox-eraumavez {
    background: transparent !important;
    transform-origin: 0% 0%;
  }

  .parallax-text-default {
    font-family: 'RongelOsf';
    font-size: 10.7px;
    line-height: 13px;
    padding: 9.375px 46.875px 9.375px 18.75px;
  }

  .parallax-text-ambepoca {
    font-family: 'Gotham Rounded Book';
    font-size: 7.8px;
    line-height: 10px;
    padding: 3px 18.75px 8px 9.375px;
  }
</style>


// WEBPACK FOOTER //
// ParallaxComposite.vue?2f1436f8